import PropTypes from "prop-types";
import React from "react";

export default function TextField(props) {
    if(props.field && props.field.length > 0){
        let additionalStyles = props.styleClass ? props.styleClass : "";
        return (
            <div className={`fieldText ${additionalStyles}`}>
                {props.field} 
            </div>
        );
    }
    else {
        return (
            <div className={`fieldText placeholder`}>
                {props.placeholder}
            </div>
        );            
    }
}

TextField.propTypes = {
    field: PropTypes.string,
    placeholder: PropTypes.string,
    styleClass: PropTypes.string
};

